import config from "~/nuxt.config";

function getCookieOptions(expiry) {
  const secure = config.env.TOKEN_COOKIE_SECURE;
  return {
    domain: config.env.TOKEN_COOKIE_DOMAIN,
    secure,
    httpOnly: config.env.TOKEN_COOKIE_HTTP_ONLY,
    sameSite: secure ? "none" : "lax",
    maxAge: expiry,
    path: "/"
  };
}

export default (app, accessToken, refreshToken, expires, token_type, idToken) => {
  // TODO: REMOVE??
  if(!process.browser) {
    if (accessToken) {
      app.$cookies.set("accessToken", accessToken, getCookieOptions(expires));
    }

    if (refreshToken) {
      app.$cookies.set("refreshToken", refreshToken, getCookieOptions(6 *  3600));
    }

    if (idToken) {
      app.$cookies.set("idToken", idToken, getCookieOptions(expires));
    }
  }

  app.$axios.setToken(accessToken, token_type);
};
